export default __webpack_public_path__ + "static/media/dataScience.5eec1981.PNG";